const doc = [({"en":({"js":({"users":({"edit":({"form":({"two_factor_authentication":({"two_factor_authentication":"Two-factor authentication"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;